export default function ({ redirect, store }) {
  if (!store.getters['auth/hasBuilderAccess']) {
    redirect('/templates')
  }
}
